type PenIconProps = {
  color: string;
};

export const PenIcon = ({ color }: PenIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 15 15"
  >
    <path fill="transparent" d="M0 0h15v15H0z" />
    <path
      d="M792.385 1085.024a2.646 2.646 0 0 0-3.741 0l-6.434 6.434a1.669 1.669 0 0 0-.47.912l-.483 2.894a.77.77 0 0 0 .76.9.729.729 0 0 0 .126-.01l2.895-.483a1.666 1.666 0 0 0 .911-.469l6.434-6.434a2.645 2.645 0 0 0 0-3.74zm-7.081 9.526a.758.758 0 0 1-.414.213l-2.692.448.448-2.692a.757.757 0 0 1 .213-.414l4.937-4.937 2.444 2.444zm6.434-6.434-.849.849-2.444-2.444.849-.849a1.728 1.728 0 1 1 2.444 2.444z"
      transform="translate(-779.875 -1082.535)"
      fill={color}
    />
  </svg>
);
